import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectToolCollection } from "../../../actions";
import UploadButton from "./UploadButton";
import { doesAnyLayerHavePhotoImages } from "../../../services/layers";

const ToolButton = ({
  id,
  name,
  activeTool,
  routeId,
  design,
  location,
  selectToolCollection
}) => {
  const handleClick = (e) => {
    e.preventDefault(); // Always prevent default navigation

    // If this tool is currently active and visible, hide it
    if (activeTool.activeTool === name && activeTool.isVisible) {
      selectToolCollection({ activeTool: name, isVisible: false });
    } else {
      // Otherwise, make this tool active and visible
      selectToolCollection({ activeTool: name, isVisible: true });
    }
  };

  // Only render if not photos tool or if design has photo images
  if (id !== "photos" || doesAnyLayerHavePhotoImages(design)) {
    return (
      <li
        id={id}
        className={`navigation__item navigation__item--${id} ${activeTool.activeTool === name ? "active" : ""}`}
        onClick={handleClick}
      >
        <Link
          className="navigation__link"
          to={{
            pathname: `/${routeId}/customize/${id}`,
            search: location.search
          }}
        >
          {
            /* SVG background for Upload tool button */
            (id === "upload" || id === "photos") && <UploadButton />
          }
          {name}
        </Link>
      </li>
    );
  } else {
    return <div />;
  }
};

// No need to map state to props since we're getting the full activeToolCollection from parent
export default connect(null, (dispatch) =>
  bindActionCreators({ selectToolCollection }, dispatch)
)(ToolButton);
